import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mpp-serial-number-hint',
  templateUrl: './serial-number-hint.component.html',
  styleUrls: ['./serial-number-hint.component.scss'],
  standalone: false,
})
export class SerialNumberHintComponent {
  constructor(private dialogRef: MatDialogRef<SerialNumberHintComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
